module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.currentUser) ? _c('div', {
    staticClass: "Meritos"
  }, [_c('headerFeed', {
    attrs: {
      "currentUser": _vm.currentUser,
      "title": "Mis Meritos"
    }
  }), _vm._v(" "), (_vm.loading) ? _c('md-progress', {
    staticClass: "md-accent",
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "contenidoPagina"
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f33f5ab8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MisMeritos.vue
// module id = 384
// module chunks = 1